import React, { Component, useState, useEffect } from "react";
import Select from "react-select";
import {NavLink, useNavigate, useSearchParams, Navigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Full_Calendar from './full-calendar';
import axios from "axios";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HomeBanner from "../images/feature-banner.png";
import Arrow from "../images/Down_Arrow_3_.svg"
import RedStar from "../images/star-red.svg"
import GreyStar from "../images/star-grey.svg"
import { changeLanguage } from "i18next";



function SearchRes(props) { 
  console.log("************************", props);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()
  console.log('searchParams', searchParams)
  
  //const zodiac = searchParams.get('zodiac');
  

  const { t, i18n } = useTranslation();
  const [startDate, setStartDate] = useState(new Date());
  const [clicked, setClicked] = useState('');
  const [clickedType, setclickedType] = useState('');
  const [searchData, setSearchData] = useState([]);  
  const [searchExtraData, setSearchExtraData] = useState([]);
  


  const [zLuck, setZLuck] = useState([]); // Zodiac luck
  const [days, setDays] = useState([]); // Zodiac luck


  ///////////////////////// SEARCH /////////////////////////
  const [searchTitle, setSearchTitle] = useState('');
  const [searchSDate, setSearchSDate] = useState(new Date());
  const [searchEDate, setSearchEDate] = useState(new Date());
  var zodiac = searchParams.get('zodiac');
  if(zodiac) {
    zodiac = zodiac.split(',');
  }
  const [selectedIds, setSelectedIds ] = useState([zodiac]);
  var seldays = searchParams.get('days');
  var seldaysURL = []
  if(seldays) {
    seldays = seldays.split(',');
    for (let i = 0;i <seldays.length; i++) {
      seldaysURL = [...seldaysURL,seldays[i]]
    };
  }
  
  const [selectedDays, setSelectedDays ] = useState([]); 
  const [allEvents, setAllEvents] = useState([]);  

  ///////////////////////// SEARCH /////////////////////////

  useEffect(()=>{


    axios.get(process.env.REACT_APP_API_KEY+"api/all-event",
    {
      params: {},
      headers: {
          "Content-type": "Application/json",
          "Accept": "Application/json",
          "Authorization": `Bearer `+token,
          "sellang": localStorage.getItem("selectLang")
      }   
    }).then((res) => {
      console.log('EEEEs: ', res);

      var re_Data = res.data; 
      
      if(re_Data.status == true){ // ?.
        setAllEvents(re_Data?.data?.event);
        setZLuck(re_Data?.data?.zodiac);
        setDays(re_Data?.data?.days);
      } else {
        swal("Oops", re_Data?.message, "error");
      }

    }).catch (error => {
    
    })


    var activitiesURL = '';
    var from_dateURL = '';
    var to_dateURL = '';
    var zodiacURL = '';
    var daysURL = '';
    
    var activities = searchParams.get('activities');
    if(activities) {
        activitiesURL = activities;
        setSearchTitle(activities);
    } else {
        setSearchTitle('');
    }
    

    const from_date = searchParams.get('from_date');
    if(from_date){
        from_dateURL = from_date;
        setSearchSDate(from_date);
    } else {
      setSearchSDate(startDate); 
    }
    

    const to_date = searchParams.get('to_date');
    
    if(to_date) {
        to_dateURL = to_date;
        setSearchEDate(to_date);
    } else {
        setSearchEDate(startDate);
    }

    console.log('EEEEEA: ',from_date, to_date)
   

    const zodiac = searchParams.get('zodiac');
    if(zodiac) {
        zodiacURL = zodiac;

        var zoURL = []
        var selzodia = zodiac.split(',');
        for (let i = 0;i <selzodia.length; i++) {
          zoURL = [...zoURL,selzodia[i]]
        };

        setSelectedIds(zoURL);
    } else {
        setSelectedIds([]);
    }

    const getdays = searchParams.get('days');
    if(getdays) {
        daysURL = getdays;
        var seldaysURL = []
        var seldays = getdays.split(',');
        for (let i = 0;i <seldays.length; i++) {
          seldaysURL = [...seldaysURL,seldays[i]]
        };

        setSelectedDays(seldaysURL);
    } else {
        setSelectedIds([]);
    }

    var paramsurl = {
      activities: activitiesURL,
      from_date: from_dateURL,
      to_date: to_dateURL,
      zodiac: zodiacURL,
      days: daysURL 
    };
    
    getAuspiciousDataByDate(paramsurl);
  },[global.selLang]);
  
  


  
  
  const getAuspiciousDataByDate = (all_params) => {
    //const postData = {'activities': searchTitle, 'from_date': searchSDate, 'to_date': searchEDate, 'zodiac': '' };
    
    
    setClicked('noaction');
    axios.get(process.env.REACT_APP_API_KEY+"api/auspicious-search",
    {
      params: all_params,
      headers: {
      "Content-type": "Application/json",
      "Accept": "Application/json",
      "Authorization": `Bearer `+token,
      "sellang": localStorage.getItem("selectLang")
      }   
    }).then((res) => {
      
      var reData = res.data; 
      
      if(reData.status == true){ // ?.
        console.log('reFullData',reData);
        setSearchData(reData?.data);
        setSearchExtraData(reData?.extraData);
        
       
      } else {
        swal("Oops", reData?.message, "error");
      }
      
      setClicked('');
    }).catch (error => {
      
      if(error?.response?.status == 401 && error?.response?.data?.message == 'Unauthenticated.') {
         localStorage.removeItem("token")
         localStorage.removeItem("userData")
         localStorage.removeItem("fname")
         localStorage.removeItem("lname")
         localStorage.removeItem("nameImage")
         localStorage.removeItem("otpCounter")
         localStorage.removeItem("USERLOGIN")
         navigate("/");
      } else {
        swal("Oops", "Something went wrong.", "error");
      }
      setClicked('');
      
     
    })
    

      
  } /* function close */

  const handleChangeDays = (event) => {
    const checked_id = event.target.value;
    if(event.target.checked){
      setSelectedDays([...selectedDays,checked_id])
    } else{
      setSelectedDays(selectedDays.filter(id=>id !== checked_id))
    }
    console.log("ItemCheckDays", selectedDays)
  }

  const handleChange = (event) => {
    const checkedId = event.target.value;
    if(event.target.checked){
     setSelectedIds([...selectedIds,checkedId])
    } else{
     setSelectedIds(selectedIds.filter(id=>id !== checkedId))
    }
    console.log("ItemCheck1", selectedIds)
  }

  function updateQueryStringParameter (uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  const serchAuspicious = () => {
    
    setclickedType('searchAuspicious');
    setClicked('noaction');
    console.log('SSS: ');
    console.log(searchTitle);
    console.log(searchSDate);
    console.log(searchEDate);
    console.log(selectedDays);

    var newDate =  new Date(searchEDate);
    var php_date = newDate.getFullYear()+'-'+(newDate.getMonth()+1); //+'-'+newDate.getDate();

    var newSDate =  new Date(searchSDate);
    var php_s_date = newSDate.getFullYear()+'-'+(newSDate.getMonth()+1); //+'-'+newSDate.getDate();
   
    var currentUrl = window.location.href;
    currentUrl = updateQueryStringParameter(currentUrl,'activities', searchTitle );
    currentUrl = updateQueryStringParameter(currentUrl,'from_date', php_s_date );
    currentUrl = updateQueryStringParameter(currentUrl,'to_date', php_date );
    currentUrl = updateQueryStringParameter(currentUrl,'zodiac', selectedIds );
    currentUrl = updateQueryStringParameter(currentUrl,'days', selectedDays );
    //var updatedUrl = currentUrl.split('?')[0] + '?' + urlParams.toString();
    console.log('currentUrl', currentUrl);
    window.history.replaceState({}, '', currentUrl);

    var paramsurl = {
      activities: searchTitle,
      from_date: php_s_date,
      to_date: php_date,
      zodiac: selectedIds,
      days: selectedDays 
    };
    
    getAuspiciousDataByDate(paramsurl)
    //setClicked('');
  }
  const serchData = () => {
    navigate("/features");
  }
  


  const getURL = (seldate) =>{
      return (
        'features?seldate='+seldate
      );
    };


return (
  <>
    <div className="feature features-header">
      {/* <img src={HomeBanner} alt="Home-Banner" id="feature-banner" className="img-fluid w-100" /> */}
      <div className="calendar-box">
        <div className="row align-items-center mb-5">
          <div  className="col-md-5 col-sm-12">
            <div className="banner-select p-3">
              <p>{t('festival_calendar')}</p>
              <div className="row">
                <div className="col-sm-8">
                  <div className="date-cover">
                  <DatePicker name="seldate" maxDate={new Date("12/31/2100")} minDate={new Date("1/1/2022")} dateFormat = "dd/MM/yyyy" selected={startDate} onChange={(date) =>   
                  setStartDate(date)} /> 
                  </div>
                </div>
                <div className="col-md-4 col-sm-12">
                  <button type="button" onClick={serchData}  disabled = {clicked == 'noaction' ? 'disabled': ''} class={`btn-red-bg btn btn-md nav-btn02 fill02 ${clicked}`}>
                   {t('festival_search_btn')}
                  </button>
                </div>
                <div>
                {/* <div className="d-flex">
                  <button type="button" onClick={serchData} disabled = {clicked == 'noaction' ? 'disabled': ''} class={`btn-red-bg btn btn-md nav-btn02 fill02 ${clicked}`}>
                    {clicked == 'noaction' ? 'Loading...': t('festival_search_btn')}
                  </button>
                </div> */}
                  {/*<!---Auspicious-----> */}
              {/*<!----Auspicious----> */}
                </div>
              </div>
            </div>
          </div>
          {/*<!---Auspicious-----> */}
          <div className="col-sm-7">
            <div className="card rounded-0">
            <div className="card-body">
              <form action="" method="get">
                <div> 
                  <h3 className="mb-4">{t('auspicious_title')}</h3>
                </div>
                <div className="row mb-3">
                  <div className="col-sm-2">
                    <label for=""><strong>{t('auspicious_event')}</strong></label>
                  </div>
                  <div className="col-sm-10">
                    <select name="" id="" className="form-control" onChange={e => setSearchTitle(e.target.value)}>
                      <option value=""></option>

                      {allEvents.map(allEvent => (
                        <option selected = {(allEvent.suit_activities == searchTitle) ? 'selected' : ''} value={allEvent.suit_activities}>{allEvent.suit_activities}</option>
                      ))}

                    </select>
                    
                    </div>
                </div>
                
              <div className="row mb-3">
                <div className="col-sm-6">
                  <div className="date-picker">
                    <label for=""><strong>{t('auspicious_from')}</strong></label>
                    <DatePicker showMonthYearPicker className="form-control"  name="selsdate" maxDate={new Date("12/31/2100")} minDate={new Date("1/1/2022")} dateFormat = "MM/yyyy" selected={(searchSDate) ? new Date(searchSDate) : startDate} onChange={(date) =>   
                  setSearchSDate(date)} />  
                  </div>
                  </div>

                <div className="col-sm-6">
                  <div className="date-picker">
                    <label for=""><strong>{t('auspicious_to')}</strong></label>
                    <DatePicker  showMonthYearPicker className="form-control" name="seledate" maxDate={new Date("12/31/2100")} minDate={new Date("1/1/2022")} dateFormat = "MM/yyyy" selected={(searchEDate) ? new Date(searchEDate) : startDate} onChange={(date) =>   
                  setSearchEDate(date)} />
                  </div>
                </div>

              </div>
              <div className="row">
                <div className="col-sm-12">
                  <label for=""><strong>{t('auspicious_res_days')}</strong></label>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-12">
                  <div className="row">
                    {days.map(zluck => (
                      <div className="col-sm-3">
                        <input checked={selectedDays.includes(zluck.id)} className="form-check-input" type="checkbox" value={zluck.id} onChange={handleChangeDays}  id={'luck_check_days'+zluck.id}/>
                        <label className="form-check-label" for={'luck_check_days'+zluck.id}>{zluck.header}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <label for=""><strong>{t('auspicious_res_zodiac')}</strong></label>
                </div>
              </div>
                <div className="row">
                  <div className="col-sm-9">
                    <div className="row">
                      {zLuck.map(zluck => (
                        <div className="col-sm-3">
                          <input checked={selectedIds.includes(zluck.id)} className="form-check-input" type="checkbox" value={zluck.id} onChange={handleChange}  id={'luck_check_'+zluck.id}/>
                          <label className="form-check-label" for={'luck_check_'+zluck.id}>{zluck.header}</label>
                        </div>
                      ))}
                    </div>
                  </div>

                  
                  <div className="col-sm-3">
                    <div className="row">
                    <button type="button" onClick={serchAuspicious} disabled = {clicked == 'noaction' ? 'disabled': ''} class={`btn-red-bg btn btn-md nav-btn02 fill02 ${clicked}`}>
                      {clicked == 'noaction' ? 'Loading...': t('auspicious_search_btn')}
                    </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            </div>
          </div>
          {/*<!----Auspicious----> */}
        </div>
      </div>
    </div>
    
    {(clicked == "noaction" ? (
      <div className="bg-grey">
        <div className="main-section-box">
          <div>Loading...</div>
        </div>
      </div>
) : (
 


      <div className="bg-grey">
        <div className="main-section-box">
          <div className="">
            <div className="zodiac-container auspicious shadow-none p-0 mt-0">
            <p className="head">{t('auspicious_res_title')}</p>
            <div className="">
              <ul style={{listStyle: "none", paddingLeft: '0'}}>
                <li><strong>{t('auspicious_event')}:</strong> {searchExtraData?.keyword}
                </li>
                <li><strong>{t('auspicious_res_period')}:</strong> {searchExtraData?.period}
                </li>
                <li><strong>{t('auspicious_res_days')}:</strong> {searchExtraData?.searchDays}
                </li>
                <li><strong>{t('auspicious_res_zodiac')}:</strong> {searchExtraData?.selectedZodiac}
                </li>
                <li><strong>{t('auspicious_res_total')}:</strong> <big className="count" style={{color: "#f00", fontWeight: 'bold'}}>{searchData?.length}</big> {t('auspicious_res_count')}
    </li>
              </ul>
            </div>
            <div className="line"></div>
            <div className="mt-4">
            
            <Table responsive="xl" className="zodiac-table">
            <thead>
              <tr>
                <th>日期 <br/> Date</th>
                <th>星期 <br/> Day</th>
                <th>指数 <br/> Rating</th>
                <th>农历 <br/> Lunar Date</th>
                <th>年干支 <br/> Year</th>
                <th>月干支 <br/> Month</th>
                <th>日干支 <br/> Day</th>
                <th>飞星 <br/> Flying Stars</th>
                <th>星宿 <br/> 28 Mansions</th>
                <th>建除 <br/> Day Officer</th>
                <th>冲犯 <br/> Conflict</th>
                <th>备注 <br/> Concerns</th>
              </tr>
            </thead>
            <tbody>
              
              {searchData?.map(search_data => (
                <tr>
                  <td>
                      <a target="_blank" href={getURL(search_data.fulldate)}>
                      {search_data.fulldate}
                      </a>
                    </td>
                  <td>{search_data.cz.day}<br/>{search_data.en.day}</td>
                  <td>{search_data.rating}</td>
                  <td>{search_data.cz.lunarData}<br/>{search_data.en.lunarData}</td>
                  <td>{search_data.cz.chDateSp.year}<br/>{search_data.en.chDateSp.year}</td>
                  <td>{search_data.cz.chDateSp.month}<br/>{search_data.en.chDateSp.month}</td>
                  <td>{search_data.cz.chDateSp.day}<br/>{search_data.en.chDateSp.day}</td>
                  <td>{search_data.cz.flying_stars}<br/>{search_data.en.flying_stars}</td>
                  <td>{search_data.cz.mansions}<br/>{search_data.en.mansions}</td>
                  <td>{search_data.cz.day_officer}<br/>{search_data.en.day_officer}</td>
                  <td>{search_data.cz.conflict}<br/>{search_data.en.conflict}</td>
                  <td>{search_data.cz.concerns}<br/>{search_data.en.concerns}</td>
                </tr>
              ))}   

              
              
              </tbody>
              </Table>
            </div>
            </div>
            

          </div>
        </div>
      </div>
      )
      )}
  </>
);
}

export default SearchRes;
